import React from 'react';
import './Button.css';

class Button extends React.Component {
    render() {
        return (
            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-1">
                <a rel="noopener noreferrer" href={this.props.link} className="header-button lite-shadow">{this.props.text}</a>
            </div>
        )
    }
}

export default Button;